(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxWorkstationListSmall (
    WorkstationListService, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        paginationObject: '=paginationObject',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/workstationsListSmall/workstationsListSmall.template.html',
      link: function(scope) {

        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        (function() {
          getFirstPage();
        })();

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;
          WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = workstations.page.totalPages;
            if (workstations.list) {
              scope.list = workstations.list;
            }
          }).catch(function(error){});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations){
              if (workstations.list) {
                scope.list = scope.list.concat(workstations.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({selectedItem: selectedItem})
        }

        scope.closePopup = function (event) {
          scope.callback({selectItem: null});
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch(tooltipScope) {
              case 'gatewayDetails':
                gatewayTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function gatewayTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Gateways',
            type: 'gatewayDetails',
            icon: null,
            workstation: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxWorkstationListSmall.$inject = ['WorkstationListService', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationListSmall', pxWorkstationListSmall);

})();
